import { render, staticRenderFns } from "./booking.vue?vue&type=template&id=4a04542c"
import script from "./booking.vue?vue&type=script&lang=js"
export * from "./booking.vue?vue&type=script&lang=js"
import style0 from "./booking.vue?vue&type=style&index=0&id=4a04542c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports